<template>
  <!--actions-bar v-if="hasRole('ueg')">
      <div class="level">
        <div class="level-left"></div>
        <div class="level-right">
          <div class="level-item">
            <router-link
              class="button is-wide is-secondary"
              :to="{ name: 'projectRequests.create' }"
            >
              Create New Form
            </router-link>
          </div>
        </div>
      </div>
    </actions-bar-->

  <div class="container">
    <app-data-view-header
      has-create
      :search.sync="search"
      :headers="headers"
      :sort="sortSettings"
      :has-view-as="false"
      :has-order-by="false"
      :order-by.sync="orderBy"
      @click:create="addUser()"
    >
    </app-data-view-header>
    <app-data-viewer
      grid-has-edit
      :loading="loadingList"
      :items="filteredItems"
      :headers="headers"
      :order-by.sync="orderBy"
      view-by="list"
      @click:list-row="editForm($event)"
    >
      <template v-slot:list.item.actions="{ item }">
        <button class="button is-text is-icon" @click.stop="editForm(item)">
          <span class="icon icon-edit"></span>
        </button>
        <button
          class="button is-text is-icon"
          @click.stop="
            deleteDialog = true;
            selectedForm = item.formID;
          "
        >
          <span class="icon icon-delete"></span>
        </button>
      </template>
    </app-data-viewer>

    <confirm-dialog
      v-model="deleteDialog"
      @confirmed="deleteForm"
    ></confirm-dialog>

    <!-- :click-row-access="hasPermission(10003)" -->
    <!-- <app-table
        :items="filteredItems"
        :headers="headers"
        @click:row="editForm($event)"
      >
      
      </app-table> -->
  </div>
</template>

<script>
import _ from 'lodash';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import AppDataViewHeader from '@/components/AppDataViewHeader.vue';
import AppDataViewer from '@/components/AppDataViewer.vue';

export default {
  name: 'FormsLists',
  components: {
    ConfirmDialog,
    AppDataViewHeader,
    AppDataViewer
  },
  data() {
    return {
      create: false,
      headers: [
        {
          text: 'Form name',
          value: 'title',
          sortable: true,
          customSort: (a, b) => {
            if (a.title.toLowerCase() < b.title.toLowerCase()) {
              return -1;
            }
            if (a.title.toLowerCase() > b.title.toLowerCase()) {
              return 1;
            }
            return 0;
          },
          width: '25%'
        },
        {
          text: 'Organizations',
          value: 'organizations',
          width: '15%'
        },
        {
          text: 'Description',
          value: 'description',
          cellClass: ' text-truncate'
        },
        {
          text: '',
          value: 'actions',
          align: 'end',
          width: 180
          // permissions: [10003]
        }
      ],
      sortSettings: [],
      loadingList: true,
      search: '',
      deleteDialog: false,
      orderBy: {}
    };
  },
  computed: {
    filteredItems() {
      return this.$store.getters['projectRequests/search'](this.search);
    }
  },
  mounted() {
    this.axiosRequest('get', 'Forms', {
      IncludeTrashed: false
      // OrganizationID: this.$store.getters.userOrganization
    })
      .then(response => {
        this.$store.commit('projectRequests/set', response.data);
        this.loadingList = false;
      })
      .catch(error => {
        this.showErrorMessage(error);
      });
  },
  methods: {
    addUser(user) {
      this.$router.push({
        name: 'projectRequests.create'
      });
    },
    editForm(form) {
      this.$router.push({
        name: 'projectRequests.view',
        params: { id: form.formID }
      });
    },
    deleteForm() {
      this.axiosRequest('delete', `Forms/${this.selectedForm}`)
        .then(() => {
          this.$store.commit('projectRequests/deleteById', this.selectedForm);
          this.deleteDialog = false;
        })
        .catch(error => {
          this.showErrorMessage(error);
        });
    }
  }
};
</script>

<style lang="scss"></style>
